import React from "react";
import "./ScrollBar.css";

const ScrollBar = (props) => {
  return (
    <div
      style={{
        height: props.height,
        overflow: "auto"
      }}
      className="custom-scrollbar"
    >
      {props.children}
    </div>
  );
};

export default ScrollBar;
